var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('v-container',{staticClass:"flex-d align-center"},[_c('canvas',{ref:"qrImage"}),_vm._v(" ID: "+_vm._s(_vm.id)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }